import type { ActivityEvent } from '@/store/activity/activitySlice'
import css from './ActivitySourceBadge.module.css'

const LABELS: Record<string, string> = { api: 'API', mcp: 'MCP' }

interface Props {
    event: ActivityEvent
}

const ActivitySourceBadge = ({ event }: Props) => {
    if (!event.source) return null
    const label = LABELS[event.source]
    if (!label) return null
    return <span className={css.badge}>{label}</span>
}

export default ActivitySourceBadge
